import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function CaretDownIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg
      height="1em"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 9.33124L1.71097e-06 0.668737L10 0.668738L5 9.33124Z"
        fill={"currentColor"}
      />
    </svg>
  );
};
